export default function AcceptCallIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="69"
      height="69"
      viewBox="0 0 69 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_15736_1709)">
        <rect
          x="9.78882"
          y="6.52588"
          width="48.9441"
          height="48.9441"
          rx="24.472"
          fill="#00C853"
          shape-rendering="crispEdges"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.3601 18.8872C26.0272 17.132 28.7847 17.4609 30.1627 19.4099L31.8771 21.8347C32.9793 23.3936 32.8862 25.561 31.5707 26.9459L31.2378 27.2964C31.2369 27.2988 31.2359 27.3015 31.2349 27.3043C31.2173 27.3537 31.1729 27.5111 31.2166 27.8099C31.3074 28.4292 31.7855 29.6878 33.7264 31.7313C35.6735 33.7812 36.8546 34.2643 37.4018 34.3532C37.6379 34.3915 37.7614 34.3582 37.8008 34.3443L38.3564 33.7594C39.5443 32.5088 41.3965 32.2624 42.8899 33.122L45.4874 34.617C47.7074 35.8949 48.2241 39.0207 46.4499 40.8886L44.5186 42.922C43.9159 43.5566 43.0939 44.0983 42.0783 44.1985C39.5986 44.4433 33.8543 44.1245 27.8323 37.7844C22.213 31.8684 21.1455 26.7226 21.0106 24.2085L21.9162 24.1599L21.0106 24.2085C20.9439 22.9663 21.4976 21.9008 22.2261 21.1338L24.3601 18.8872ZM28.4975 20.5872C27.8009 19.602 26.5496 19.5433 25.8387 20.2916L23.7048 22.5383C23.2542 23.0126 23.0178 23.5563 23.047 24.0992C23.1572 26.1519 24.0411 30.8318 29.3109 36.38C34.8364 42.1973 39.927 42.3616 41.8779 42.169C42.2637 42.131 42.6606 41.9169 43.04 41.5175L44.9713 39.4842C45.8044 38.607 45.586 37.0268 44.47 36.3845L41.8726 34.8894C41.1756 34.4882 40.359 34.6122 39.835 35.1639L39.2158 35.8158L38.4991 35.135C39.2158 35.8158 39.2148 35.8168 39.2139 35.8178L39.212 35.8198L39.2079 35.824L39.1993 35.8328L39.1798 35.852C39.1658 35.8655 39.1497 35.8805 39.1314 35.8965C39.0948 35.9285 39.0496 35.9651 38.9953 36.0036C38.8864 36.0809 38.7413 36.1658 38.5579 36.2382C38.1826 36.3862 37.6871 36.4656 37.0749 36.3661C35.8819 36.1724 34.3182 35.3155 32.2478 33.1357C30.1713 30.9495 29.3766 29.3184 29.1988 28.1056C29.1084 27.4882 29.1808 26.9939 29.3136 26.6206C29.3789 26.437 29.4561 26.2907 29.5272 26.1795C29.5627 26.1241 29.5965 26.0777 29.6264 26.0399C29.6413 26.021 29.6553 26.0043 29.668 25.9897L29.6861 25.9693L29.6944 25.9603L29.6983 25.956L29.7003 25.954C29.7012 25.953 29.7021 25.952 30.425 26.6386L29.7022 25.952L30.0921 25.5415C30.6978 24.9038 30.7858 23.8237 30.2119 23.012L28.4975 20.5872Z"
          fill="white"
        />
        <path
          d="M35.9733 17.2393C36.0633 16.6834 36.5889 16.3063 37.1448 16.3963C37.1792 16.4029 37.2899 16.4236 37.3479 16.4365C37.4639 16.4624 37.6257 16.5021 37.8275 16.5609C38.231 16.6784 38.7947 16.872 39.4712 17.1822C40.8257 17.8032 42.6282 18.8895 44.4987 20.76C46.3692 22.6304 47.4555 24.433 48.0765 25.7875C48.3866 26.464 48.5802 27.0277 48.6978 27.4312C48.7565 27.6329 48.7963 27.7948 48.8222 27.9108C48.8351 27.9688 48.8445 28.0154 48.8511 28.0498L48.8589 28.0922C48.9489 28.6481 48.5752 29.1953 48.0193 29.2853C47.465 29.3751 46.9428 28.9998 46.8506 28.4465C46.8478 28.4316 46.84 28.3917 46.8316 28.3541C46.8148 28.2788 46.7858 28.1594 46.7398 28.0015C46.6478 27.6856 46.488 27.2161 46.2227 26.6374C45.6927 25.4813 44.7396 23.8849 43.0567 22.202C41.3737 20.5191 39.7774 19.566 38.6213 19.036C38.0426 18.7707 37.5731 18.6109 37.2572 18.5189C37.0993 18.4729 36.9008 18.4273 36.8255 18.4106C36.2722 18.3184 35.8836 17.7937 35.9733 17.2393Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M36.2814 21.9293C36.4361 21.3878 37.0005 21.0742 37.542 21.2289L37.2619 22.2094C37.542 21.2289 37.5425 21.2291 37.543 21.2292L37.544 21.2295L37.546 21.2301L37.5506 21.2314L37.5611 21.2346L37.588 21.243C37.6085 21.2495 37.6341 21.2581 37.6646 21.2689C37.7257 21.2906 37.8064 21.3214 37.9054 21.3638C38.1034 21.4487 38.3741 21.5798 38.7065 21.7765C39.372 22.1703 40.2804 22.8245 41.3476 23.8918C42.4148 24.959 43.069 25.8674 43.4629 26.5329C43.6596 26.8653 43.7907 27.1359 43.8756 27.334C43.918 27.433 43.9488 27.5137 43.9705 27.5747C43.9813 27.6053 43.9899 27.6309 43.9964 27.6514L44.0048 27.6783L44.0079 27.6888L44.0093 27.6933L44.0099 27.6954L44.0101 27.6964C44.0103 27.6969 44.0104 27.6974 43.03 27.9775L44.0104 27.6974C44.1651 28.2389 43.8516 28.8032 43.3101 28.9579C42.7732 29.1113 42.2138 28.8044 42.0536 28.2714L42.0486 28.2567C42.0413 28.2363 42.0263 28.1961 42.0011 28.1373C41.9508 28.0199 41.8596 27.8279 41.7079 27.5715C41.4047 27.0593 40.8572 26.2854 39.9056 25.3338C38.954 24.3822 38.18 23.8347 37.6678 23.5315C37.4114 23.3798 37.2194 23.2885 37.102 23.2382C37.0433 23.2131 37.0031 23.1981 36.9827 23.1908L36.968 23.1858C36.435 23.0255 36.128 22.4661 36.2814 21.9293Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_15736_1709"
          x="-1.90735e-06"
          y="-1.43051e-06"
          width="68.5217"
          height="68.5217"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.26294" />
          <feGaussianBlur stdDeviation="4.89441" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15736_1709"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15736_1709"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
